<template>
  <div class="row">
    <div
      v-for="{
        as,
        name,
        type,
        label,
        column,
        useLabel,
        ...attrs
      } in schema.fields"
      :key="name"
      :class="`col-md-${column} mb-3`"
    >
      <label v-if="useLabel" :for="name" class="form-control-label">{{
        label
      }}</label>
      <Field
        class="form-control"
        :as="as"
        :id="name"
        :name="name"
        :type="type"
        :placeholder="name"
        v-bind="attrs"
        v-model="formValues[name]"
      />
      <ErrorMessage class="text-danger" :name="name" />
    </div>
  </div>
</template>

<script>
import { defineComponent, ref } from "vue";
import { Field, ErrorMessage } from "vee-validate";
export default defineComponent({
  name: "dynamic-form",
  components: {
    Field,
    ErrorMessage,
  },
  props: {
    schema: {
      type: Object,
      required: true,
    },
    formData: {
      type: Object,
      required: true,
    },
  },
  setup(props) {
    const formValues = ref(props.formData);
    return {
      formValues,
      ...props,
    };
  },
});
</script>
